import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import SearchResultEntry from "./SearchResultEntry";

SearchResults.propTypes = {
  data: PropTypes.object,
  signupItemID: PropTypes.number,
  closePopover: PropTypes.func,
  setSuccessMessage: PropTypes.func,
};

export default function SearchResults({
  data,
  signupItemID,
  closePopover,
  setSuccessMessage,
}) {
  if (data === null) return null;

  if (data?.error)
    return (
      <Error>
        Oh no! There was a problem loading search results. Please try again
        later.
      </Error>
    );

  if (data.results.length === 0)
    return <NoResults>I couldn&apos;t find anyone with that name.</NoResults>;

  const list = {
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
      },
    },
    hidden: {
      opacity: 0,
    },
  };

  return (
    <List initial="hidden" animate="visible" variants={list}>
      {data.results.map((result) => (
        <SearchResultEntry
          key={result.userID}
          result={result}
          defaultPhoto={data.defaultPhoto}
          signupItemID={signupItemID}
          closePopover={closePopover}
          setSuccessMessage={setSuccessMessage}
        />
      ))}
    </List>
  );
}

const Error = styled.div`
  font-size: 13px;
  padding: 5px;
`;

const NoResults = styled.div`
  color: white;
  font-size: 15px;
  padding: 5px;
`;

const List = styled(motion.ul)`
  max-height: 240px;
  overflow-x: hidden;
  overflow-y: auto;
  margin: 5px 0 0;
  padding: 0;
  list-style: none;
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: white;
`;
